import { createRoutine } from "../utils/routine.utils";
export var getActivities = createRoutine("ACTIVITIES_GET");
export var getActivitiesPaged = createRoutine("ACTIVITIES_GET_PAGED");
